<button [nbPopover]="doctree" class="btn btn-default btn-sm" style="margin: 3px !important" (click)="setTree()" title="document tree"><i class="ion-android-list"></i></button>


<ng-template #doctree>

<div class="container">
  <h4>Document tree</h4>
  <br>
  <div *ngFor="let item of tree">
    <h5 [class.doc-tree-item]="item.type == 'doc'"><a [routerLink]="[]" (click)="showDoc(item.model)">
      <span *ngIf="item.type == 'doc'" [ngClass]="{ 'doc-tree-item': true, 'tree-cancelled': item.cancelled }">{{item.space}} {{item.name}}</span>
      <span *ngIf="item.type == 'cancelled'" [ngClass]="{ 'doc-tree-item': true, 'tree-cancelled': item.cancelled }">{{item.space}} {{item.name}}</span>
      <span *ngIf="item.type == 'pfspo'" [ngClass]="{ 'pfspo-tree-item': true, 'tree-cancelled': item.cancelled }"><span>{{item.space}}</span> {{item.name}}</span>
      <span *ngIf="item.type == 'pfspc'" [ngClass]="{ 'pfspc-tree-item': true, 'tree-cancelled': item.cancelled }"><span>{{item.space}}</span> {{item.name}}</span>
      <span *ngIf="item.type == 'cs'" [ngClass]="{ 'cs-tree-item': true, 'tree-cancelled': item.cancelled }"><span>{{item.space}}</span> {{item.name}}</span>
    </a></h5>
  </div>
  <br>
  <div class="footer">
    <button class="btn btn-success btn-lg"  (click)="hide()">Ok</button>
  </div>
</div>

</ng-template>
